var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-app',{class:[_vm.applicationClasses, _vm.$i18n.locale],attrs:{"id":"app","light":_vm.isLight,"dark":_vm.isDark}},[_c('v-content',[_c('v-container',{attrs:{"id":"app-contents","fluid":"fluid","grid-list-sm":"grid-list-sm"}},[_c('router-view')],1)],1)],1)}
var staticRenderFns = []
export { render, staticRenderFns }


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-5545ff4d","hasScoped":true,"optionsId":"0","buble":{"transforms":{}}}!./node_modules/vue-loader/lib/template-compiler/preprocessor.js?engine=pug&optionsId=0!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/common/layouts/Simple.vue
// module id = null
// module chunks = 